<template>
    <div>
        <!-- 中奖弹框 虚拟奖品 -->
        <virtualAwardModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="virtualAwardModal"
            @refreshRecord="getRecord"
            @nextStep="nextStep">
        </virtualAwardModal>
        <!-- 实物中奖用户信息录入 -->
        <kindAwardModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="kindAwardModal"
            :referrFlag="referrFlag"
            @refreshRecord="getRecord"
            @nextStep="nextStep"></kindAwardModal>
        <!-- 中奖弹框 未中奖 -->
        <noAwardModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="noAwardModal"
            @refreshRecord="getRecord"
            @nextStep="nextStep">
        </noAwardModal>
        <!-- 中奖弹框 积分 -->
        <pointModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="pointModal"
            @refreshRecord="getRecord"
            @nextStep="nextStep"></pointModal>
        <!-- 中奖弹框 实物奖品 -->
        <receiveAwardModal :activityUrl="activityUrl"
            :awardObj="awardObj"
            :modalButtonText="modalButtonText"
            :activityObj="activityObj"
            :drawType="drawType"
            ref="receiveAwardModal"
            :miniFlag="miniprogramFlag"
            @openKindAwardModal="openKindAwardModal"
            @nextStep="nextStep"></receiveAwardModal>
        <!-- 中奖弹框 优惠券/代金券 -->
        <couponModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="couponModal"
            @nextStep="nextStep"></couponModal>
        <!-- 虚拟奖品用户信息录入弹窗 -->
        <virtualizedAwardModal :activityUrl="activityUrl"
            :awardObj="awardObj"
            :userInfoList="userInfoList"
            :isFilledFlag="isFilledFlag"
            :modalButtonText="modalButtonText"
            :activityObj="activityObj"
            :drawType="drawType"
            ref="virtualizedAwardModal"
            :miniFlag="miniprogramFlag"
            :referrFlag="referrFlag"
            @openVirtualAwardModal="openVirtualAwardModal"
            @openReceiveAwardModal="openReceiveAwardModal"
            @refreshRecord="getRecord"
            @nextStep="nextStep"></virtualizedAwardModal>
    </div>
</template>
<script>
import virtualAwardModal from '../../dynamicAttr/modal/virtualAwardModal';
import kindAwardModal from '../../dynamicAttr/modal/kindAwardModal';
import virtualizedAwardModal from '../../dynamicAttr/modal/virtualizedAwardModal';
import noAwardModal from '../../dynamicAttr/modal/noAwardModal';
import pointModal from '../../dynamicAttr/modal/pointModal';
import receiveAwardModal from '../../dynamicAttr/modal/receiveAwardModal';
import couponModal from '../../dynamicAttr/modal/couponModal';
export default {
  components: {
    virtualAwardModal,
    kindAwardModal,
    noAwardModal,
    pointModal,
    receiveAwardModal,
    couponModal,
    virtualizedAwardModal
  },
  props: {
    awardObj: {},
    activityObj: {},
    referrFlag: '',
    activityUrl: '',
    drawType: '',
    miniprogramFlag: '',
    modalButtonText: String,
    userInfoList: Array,
    isFilledFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getRecord() {
      this.$emit('getRecord');
    },
    nextStep(link,type) {
      this.$emit('nextStep',link,type);
    },
    openKindAwardModal() {
      this.$emit('openKindAwardModal');
    },
    openVirtualAwardModal() {
      this.$emit('openVirtualAwardModal');
    },
    openReceiveAwardModal() {
      this.$emit('openReceiveAwardModal');
    }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/result-dialog.vue